import { useDocumentGroupContext } from '@/creditflowresearch/application/Research/DocumentGroupContext';
import { useResearchFilterContext } from '@/creditflowresearch/application/Research/ResearchFilterContext';
import { IResearchData } from '@/creditflowresearch/domain/vo/research/IResearchData';
import {
  IResearchPayloadOverrides,
  IResearchRequestPayload,
} from '@/creditflowresearch/domain/vo/research/IResearchResponse';

type TResearchPayloadState = Pick<IResearchData, 'sortBy' | 'sortOrder' | 'page' | 'perPage'>;

export const useResearchPayloadBuilder = (
  state: TResearchPayloadState,
  requestPayload: IResearchRequestPayload,
  searchFieldValue: string | string[],
) => {
  const { documentGroup } = useDocumentGroupContext();
  const { filtersPayload } = useResearchFilterContext();

  const prepareResearchPayload = (
    payloadData: IResearchPayloadOverrides = {},
  ): IResearchRequestPayload => {
    const { sortBy, sortOrder, page, perPage } = state;
    const { filter: filterOverrides, ...restOverrides } = payloadData;

    return ({
      ...requestPayload,
      sortBy,
      sortOrder,
      page,
      perPage,
      search: searchFieldValue,
      ...restOverrides,
      filter: {
        ...requestPayload.filter,
        ...filtersPayload,
        includedDocumentGroupId: documentGroup ? documentGroup.groupId : null,
        ...filterOverrides,
      },
    });
  };

  return {
    prepareResearchPayload,
  };
};
